import React from 'react';
import { Hero } from './components/Hero';
import { TopTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ProductOverview } from './components/ProductOverview';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Pricing } from './components/Pricing';
import { PackEliteDetails } from './components/PackEliteDetails';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Comparison } from './components/Comparison';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-0">
      <Hero data-id="element-1" />
      <TopTestimonials data-id="element-2" />
      <PainPoints data-id="element-3" />
      <ProductOverview data-id="element-4" />
      <Tomos data-id="element-5" />
      <Bonos data-id="element-6" />
      <Pricing data-id="element-7" />
      <PackEliteDetails data-id="element-8" />
      <ExtendedTestimonials data-id="element-9" />
      <Guarantee data-id="element-10" />
      <FAQ data-id="element-11" />
      <Comparison data-id="element-12" />
      {/* Second Pricing Section (Duplicate as requested) */}
      <Pricing data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}